import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { BadgeComponent } from '../crm-promotion/badge.component';
import { BadgeAndRibbonVisibilityOptions, FixtureTile } from './marquee-tile.model';
import { PrizeBoostBadgeComponent } from './prize-boost-badge.component';

@Component({
    selector: 'ms-special-marquee-badge',
    templateUrl: './special-marquee-badge.component.html',
    styleUrl: './special-marquee-badge.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconCustomComponent, BadgeComponent, PrizeBoostBadgeComponent],
})
export class SpecialMarqueeBadgeComponent implements OnChanges {
    @Input() tile: FixtureTile;
    @Input() showIcon?: boolean = true;
    @Input() showPrizeBoostBadge: boolean = false;
    badge: IBadgeData = { icon: '', title: '', shouldShow: true, isPromoBadge: false };

    ngOnChanges(): void {
        this.setBadgeData();
    }

    private setBadgeData(): void {
        if (this.showIcon) {
            this.badge.icon = this.tile.event ? 'sports-' + this.tile.event.sport.id : '';
        }

        switch (this.tile.badgeAndRibbonVisibilityOption) {
            case BadgeAndRibbonVisibilityOptions.ShowBadgeWithoutTitleOverride: {
                if (!this.tile.event) {
                    this.badge.shouldShow = false;
                } else {
                    this.badge.title = this.tile.event.league.name;
                }
                break;
            }
            case BadgeAndRibbonVisibilityOptions.ShowBadgeWithTitleOverride: {
                if (!this.tile.badgeTitle && !this.tile.event) {
                    this.badge.shouldShow = false;
                } else {
                    this.badge.title = this.tile.badgeTitle || this.tile.event.league.name;
                }
                break;
            }
            case BadgeAndRibbonVisibilityOptions.ShowPromoRibbon: {
                this.badge.isPromoBadge = true;
                break;
            }
            case BadgeAndRibbonVisibilityOptions.DoNotShowAnyBadgeOrRibbon: {
                this.badge.shouldShow = false;
                break;
            }
            default: {
                this.badge.title = this.tile.badgeTitle ? this.tile.badgeTitle : this.tile.event.league.name;
            }
        }
    }
}

export interface IBadgeData {
    icon: string;
    title: string;
    shouldShow: boolean;
    isPromoBadge: boolean;
}
